export default __webpack_public_path__ + "static/media/11.b26776dc.jpg";